
import angular from 'angular';

import { GeracaoDeMarcacoesPadraoIndexController } from './index/geracao-de-marcacoes-padrao.index.controller';
import { GeracaoDeMarcacoesPadraoNewController } from './new/geracao-de-marcacoes-padrao.new.controller';
import { GeracaoDeMarcacoesPadraoShowController } from './show/geracao-de-marcacoes-padrao.show.controller';

import { PeriodoDeApuracaoFormComponent } from './new/form/periodo-de-apuracao/periodo-de-apuracao.form.component';
import { SelecaoDeColaboradoresFormComponent } from './new/form/selecao-de-colaboradores/selecao-de-colaboradores.form.component';
import { ColaboradoresResultadoTableComponent } from './show/components/colaboradores-resultado-table/colaboradores-resultado-table.component';
import { HistoricoGeracaoComponent } from './show/components/historico-geracao/historico-geracao.component';

import { VisualizacaoPreviaGeracaoModalController } from './modals/visualizacao-previa-geracao/visualizacao-previa-geracao.modal.controller';
import { VisualizacaoPreviaGeracaoModalService } from './modals/visualizacao-previa-geracao/visualizacao-previa-geracao.modal.service';

import { GeracaoDeMarcacoesPadraoService } from './geracao-de-marcacoes-padrao.service';
import { GeracaoDeMarcacoesPadraoListRouting } from './geracao-de-marcacoes-padrao.routes';

export const GeracaoDeMarcacoesPadraoModule = angular.module('GeracaoDeMarcacoesPadraoModule', ['ui.router.state'])
    .controller('GeracaoDeMarcacoesPadraoIndexController', GeracaoDeMarcacoesPadraoIndexController)
    .controller('GeracaoDeMarcacoesPadraoNewController', GeracaoDeMarcacoesPadraoNewController)
    .controller('VisualizacaoPreviaGeracaoModalController', VisualizacaoPreviaGeracaoModalController)
    .controller('GeracaoDeMarcacoesPadraoShowController', GeracaoDeMarcacoesPadraoShowController)
    .service('GeracaoDeMarcacoesPadraoService', GeracaoDeMarcacoesPadraoService)
    .service('VisualizacaoPreviaGeracaoModalService', VisualizacaoPreviaGeracaoModalService)
    .component('periodoDeApuracaoFormComponent', PeriodoDeApuracaoFormComponent)
    .component('selecaoDeColaboradoresFormComponent', SelecaoDeColaboradoresFormComponent)
    .component('colaboradoresResultadoTableComponent', ColaboradoresResultadoTableComponent)
    .component('historicoGeracaoComponent', HistoricoGeracaoComponent)
    .config(GeracaoDeMarcacoesPadraoListRouting)
    .name;
